export enum ChartTypes {
	BarChart = 0,
	SpiderWebChart = 1,
}
